import { render, staticRenderFns } from "./CardData.vue?vue&type=template&id=ca32df8a&"
import script from "./CardData.vue?vue&type=script&lang=js&"
export * from "./CardData.vue?vue&type=script&lang=js&"
import style0 from "./CardData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports